import React from "react";
import CRMInputGeneralComponent from "../../components/CRMInputs/CRMInputGeneralComponent/CRMInputGeneralComponent";
import { CRMListingStatusChips } from "../../components/CRM/CRMListings/CRMListingStatusChips";
import { CRMListingTable } from "../../components/CRM/CRMListings/CRMListingTable";
import { CRMPageWrap } from "../../components/Simple/CRMPageWrap/CRMPageWrap";
import { CRMCardOutside } from "../../components/CRMCardOutside/CRMCardOutside";
import { CRMPadding } from "../../components/Simple/CRMPadding/CRMPadding";
import { CRMTitleSection } from "../../components/CRMTitleSection/CRMTitleSection";
import { CRMSpacingColumn } from "../../components/CRMSpacingColumn/CRMSpacingColumn";
import { TContainerStateProps } from "../../state/TContainerStateProps";
import { CRMHomesMenuBarContainer } from "../../containers/CRMHomesMenuBarContainer/CRMHomesMenuBarContainer";
import { createChangeRouteAction } from "../../state/router/createChangeRouteAction";
import * as Listing3 from "../../../../domain/models/Listing3";

class CRMListingsPage extends React.Component<React.PropsWithChildren<TContainerStateProps>> {
    public render(): JSX.Element {
        const listingsState = this.props.state.activeData.crm.listings;
        const response = listingsState.results.meta;

        const goToListing = (listing: Listing3.T, visibleTab: string): void =>
            this.props.dispatch(createChangeRouteAction(
                "VIEW_CRM_LISTING",
                { listingId: listing.id },
                { visible_tab: visibleTab, visible_sections: "" },
            ));

        return (
            <CRMPageWrap>
                <CRMHomesMenuBarContainer {...this.props} />

                <div className="crmListingsPage__sectionsContainer">
                    <CRMCardOutside borderRounding="none" shadow={true}>
                        <CRMPadding size="large">
                            <CRMSpacingColumn spacing="large">
                                <CRMTitleSection>
                                    All Listings
                                </CRMTitleSection>

                                <div className="crmListingsPage__searchBar">
                                    <CRMInputGeneralComponent
                                        inputType="text"
                                        displayError={false}
                                        placeholder="Search listings by address..."
                                        value={listingsState.addressSearch}
                                        onChange={(searchInput) => this.props.dispatch({
                                            type: "CRM_LISTINGS_SEARCH_CHANGED",
                                            payload: searchInput,
                                        })}
                                    />
                                </div>

                                <CRMListingStatusChips
                                    selectedStatus={listingsState.selectedStatus}
                                    statusCounts={listingsState.statusCounts}
                                    onSelect={(status) => this.props.dispatch({
                                        type: "CRM_LISTINGS_SELECT_STATUS",
                                        payload: { status },
                                    })}
                                />

                                {/* No pagination on this page: the actions layer fetches every listing
                                    for the selected status, so "load more" is intentionally off. */}
                                <CRMListingTable
                                    listings={response.data}
                                    showLoadMore={false}
                                    onLoadMore={() => undefined}
                                    onListingClick={(listing) => goToListing(listing, "")}
                                    onSellerClick={(listing) => goToListing(listing, "seller_details")}
                                />
                            </CRMSpacingColumn>
                        </CRMPadding>
                    </CRMCardOutside>
                </div>
            </CRMPageWrap>
        );
    }
}

export default CRMListingsPage;
